
import { subcontractJobColNm } from "constants/subcontractConstant";
import { grey } from "@mui/material/colors";
import { BoxFR } from "components/BoxCustom";
import { LocalGasStationRounded } from "resource/muiImport";
import { numberFormat } from "utils";

// A fuel-banded row shows its price at the latest fuel price (blank when out of every band)
export const scJobUntPrCol = {
  field: 'UntPr',
  headerName: subcontractJobColNm.UntPr,
  width: 120,
  align: 'right',
  valueGetter: (params) => params.row.IsFuel ? params.row.UntPrWFuel : params.row.UntPr,
  renderCell: (params) => (params.row.IsFuel ?
    <BoxFR justifyContent="space-between" width="100%">
      <LocalGasStationRounded sx={{ color: grey[500] }} />
      {params.row.UntPrWFuel != null ? numberFormat(+params.row.UntPrWFuel) : "-"}
    </BoxFR>
    :
    numberFormat(+params.row.UntPr)
  )
}

const columns= [
  {
    field: 'No',
    headerName: 'ลำดับ',
    width: 70,
    align: 'center',
  },
  {
    field: 'JobSNm',
    headerName: "งาน",
    width: 250,
  },
  {
    field: 'ScSNm',
    headerName: subcontractJobColNm.ScSNm,
    width: 250,
  },
  {
    field: 'POINm',
    headerName: subcontractJobColNm.POIId,
    width: 150,
  },
  {
    field: 'ShpmTypNm',
    headerName: subcontractJobColNm.ShpmTypId,
    width: 100,
  },
  {
    field: 'ContSize',
    headerName: "ขนาดตู้",
    width: 80,
    align: 'center'
  },
  {
    field: 'ContTyp',
    headerName: "ประเภทตู้",
    width: 100,
    align: 'center'
  },
  {
    field: 'TlrTyp',
    headerName: "ประเภทหาง",
    width: 100,
    align: 'center'
  },
  scJobUntPrCol,
  {
    field: 'Prty',
    headerName: subcontractJobColNm.Prty,
    width: 90,
    align: 'center',
  },
  {
    field: 'Rmk',
    headerName: subcontractJobColNm.Rmk,
    flex: 1,
  }
]

export default columns